import script from "./AdminPannel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPannel.vue?vue&type=script&setup=true&lang=js"

import "./AdminPannel.vue?vue&type=style&index=0&id=c7eaa0c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7eaa0c4"]])

export default __exports__